/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetOrganizationsIdMembersQueryResponse,
  GetOrganizationsIdMembersPathParams,
  GetOrganizationsIdMembers500,
} from "../types/GetOrganizationsIdMembers.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOrganizationsIdMembersQueryKey = (
  id: GetOrganizationsIdMembersPathParams["id"] | undefined,
) => [{ url: "/organizations/:id/members", params: { id: id } }] as const;

export type GetOrganizationsIdMembersQueryKey = ReturnType<
  typeof getOrganizationsIdMembersQueryKey
>;

/**
 * @summary Получение списка участников организации
 * {@link /organizations/:id/members}
 */
export async function getOrganizationsIdMembers(
  id: GetOrganizationsIdMembersPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetOrganizationsIdMembersQueryResponse,
    ResponseErrorConfig<GetOrganizationsIdMembers500>,
    unknown
  >({ method: "GET", url: `/organizations/${id}/members`, ...requestConfig });
  return res;
}

export function getOrganizationsIdMembersQueryOptions(
  id: GetOrganizationsIdMembersPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getOrganizationsIdMembersQueryKey(id);
  return queryOptions<
    ResponseConfig<GetOrganizationsIdMembersQueryResponse>,
    ResponseErrorConfig<GetOrganizationsIdMembers500>,
    ResponseConfig<GetOrganizationsIdMembersQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getOrganizationsIdMembers(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Получение списка участников организации
 * {@link /organizations/:id/members}
 */
export function useGetOrganizationsIdMembers<
  TData = ResponseConfig<GetOrganizationsIdMembersQueryResponse>,
  TQueryData = ResponseConfig<GetOrganizationsIdMembersQueryResponse>,
  TQueryKey extends QueryKey = GetOrganizationsIdMembersQueryKey,
>(
  id: GetOrganizationsIdMembersPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetOrganizationsIdMembersQueryResponse>,
        ResponseErrorConfig<GetOrganizationsIdMembers500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getOrganizationsIdMembersQueryKey(id);

  const query = useQuery(
    {
      ...getOrganizationsIdMembersQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetOrganizationsIdMembers500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
